var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripleDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 20C11.6665 20 11.3831 19.8833 11.1498 19.65C10.9165 19.4167 10.7998 19.1333 10.7998 18.8C10.7998 18.4667 10.9165 18.1833 11.1498 17.95C11.3831 17.7167 11.6665 17.6 11.9998 17.6C12.3331 17.6 12.6165 17.7167 12.8498 17.95C13.0831 18.1833 13.1998 18.4667 13.1998 18.8C13.1998 19.1333 13.0831 19.4167 12.8498 19.65C12.6165 19.8833 12.3331 20 11.9998 20ZM11.9998 13.2C11.6665 13.2 11.3831 13.0833 11.1498 12.85C10.9165 12.6167 10.7998 12.3333 10.7998 12C10.7998 11.6667 10.9165 11.3833 11.1498 11.15C11.3831 10.9167 11.6665 10.8 11.9998 10.8C12.3331 10.8 12.6165 10.9167 12.8498 11.15C13.0831 11.3833 13.1998 11.6667 13.1998 12C13.1998 12.3333 13.0831 12.6167 12.8498 12.85C12.6165 13.0833 12.3331 13.2 11.9998 13.2ZM11.9998 6.4C11.6665 6.4 11.3831 6.28333 11.1498 6.05C10.9165 5.81667 10.7998 5.53333 10.7998 5.2C10.7998 4.86667 10.9165 4.58333 11.1498 4.35C11.3831 4.11667 11.6665 4 11.9998 4C12.3331 4 12.6165 4.11667 12.8498 4.35C13.0831 4.58333 13.1998 4.86667 13.1998 5.2C13.1998 5.53333 13.0831 5.81667 12.8498 6.05C12.6165 6.28333 12.3331 6.4 11.9998 6.4Z",
    fill: "#505054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleDots);
export default __webpack_public_path__ + "static/media/tripleDots.2aaabadf78d3a69e357fde978cc2ccaa.svg";
export { ForwardRef as ReactComponent };